export default {
  menu: {
    title: 'Menú General',
    sales: 'Venta semanal sugerida',
    menu: 'Menú'
  },
  kitchen: {
    title: 'Recetario',
    recipes: 'Recetas',
    subrecipes: 'Subrecetas',
    combos: 'Paquetes',
    menu: 'Menu'
  },
  production: {
    title: 'Producción',
    production: 'Producción',
    decrease: 'Merma'
  },
  decrease: {
    title: 'Salida de inventario'
  },
  purchase: {
    title: 'Historial de pedidos',
    inbox: 'Nuevos pedidos',
    toConfirm: 'Pedidos por confirmar',
    toInvoice: 'Pedidos por facturar',
    toDeliver: 'Pedidos por entregar',
    list: 'Ordenes de compra',
    balance: 'Agregar saldo',
    manualPurchase: 'Pedido manual',
    invoices: 'Facturas',
    intelligentPurchase: 'Pedido inteligente'
  },
  inventory: {
    title: 'Almacén',
    trackProducts: 'Productos en inventario',
    read: 'Análisis',
    capture: 'Captura',
    decrease: 'Mermas'
  },
  invoices: {
    reinvoice: 'Refacturar'
  },
  management: {
    title: 'Mi restaurante',
    reports: 'Reportes',
    movements: 'Movimientos',
    commission: 'Comisiones',
    purchases: 'Compras generadas',
    contability: 'Contabilidad',
    dashboard: 'Dashboard'
  },
  settings: {
    title: 'Ajustes',
    areas: 'Areas',
    providers: 'Proveedores',
    sections: 'Secciones',
    users: 'Usuarios',
    restaurant: 'Restaurant',
    taxInformation: 'Información fiscal',
    bankInformation: 'Información bancaria',
    notification: 'Notificaciones',
    pointSale: 'Punto de venta',
    delivery: 'Polígono de entregas',
    income: 'Ingresos',
    paymentMethod: 'Formas de pago',
    outgoing: 'Egresos',
    bankAndAccounts: 'Bancos y cuentas',
    balance: 'Saldo'
  },
  sales: {
    title: 'Ventas',
    delivery: 'Para llevar',
    balance: 'Balance de ventas'
  },
  catalog: 'Catálogo de productos',
  deposits: 'Mis pagos',
  taxes: 'Mis impuestos',
  issues: 'Reclamaciones',
  provider_users: 'Usuarios',
  finances: {
    settings: 'Configuración financiera',
    accounts: 'Bancos y cuentas',
    incomeCategories: 'Categorías de ingreso',
    outgoingCategorires: 'Categorías de egreso',
    movements: 'Movimientos financieros',
    registerMovements: 'Registro de movimientos',
    bankReconciliation: 'Conciliación bancaria',
    paymentMethods: 'Métodos de pago'
  },
  movements: {
    title: 'Movimientos',
    transactions: 'Transacciones Bancarias',
    otherMovements: 'Otros Movimientos'
  },
  income: {
    title: 'Ingresos',
    cashClosings: 'Cortes',
    collection: 'Cobranza',
    billing: 'Facturación',
    movements: 'Otros movimientos'
  },
  expense: {
    title: 'Egresos',
    paymentOrders: 'Ordenes de pago',
    conciliation: 'Conciliación Bancaria',
    invoice: 'Buzón de Facturas',
    movements: 'Otros movimientos'
  },
  clients: 'Clientes'
}
